import type { FrontIconProps } from './types';

export const withDynamicStroke =
  (Icon: React.FC<FrontIconProps>) =>
  ({ size = 24, strokeWidth, ...props }: FrontIconProps) => {
    const calculatedStroke =
      strokeWidth ?? (size >= 24 ? 1.5 : size >= 20 ? 1.35 : size >= 16 ? 1.25 : 1.0);

    return <Icon {...props} width={size} height={size} strokeWidth={calculatedStroke} />;
  };
